import React from 'react';
import NumpadWrapper from './numpadWrapper';
import NumpadRow from './numpadRow';
import NumpadInput from './numpadInput';
import NumpadKeyBoard from './numpadKeyBoard';
import NumpadFooterButtons from './numpadFooterButtons';
import './numbad-styles.scss';

function NumPad({ isNumpadActive, setIsNumpadActive }) {
  return (
    <NumpadWrapper isNumpadActive={isNumpadActive} setIsNumpadActive={setIsNumpadActive}>
      <NumpadRow />
      <NumpadInput />
      <NumpadKeyBoard />
      <NumpadFooterButtons setIsNumpadActive={setIsNumpadActive} />
    </NumpadWrapper>
  );
}

export default NumPad;
